module.exports = __webpack_public_path__ + "img/pg.pg7248ade.svg";